import React from 'react';
import { graphql, useFragment } from 'react-relay';
import Lozenge, { type ThemeAppearance } from '@atlaskit/lozenge';
import { type MessageDescriptorV2, useIntl } from '@atlassian/jira-intl';
import type {
	DevOpsPullRequestStatus,
	prStatusLozenge_softwareCodePage_PRStatusLozengeFragment$key,
} from '@atlassian/jira-relay/src/__generated__/prStatusLozenge_softwareCodePage_PRStatusLozengeFragment.graphql';
import messages from './messages';

export const getLozengeConfig = (
	status: DevOpsPullRequestStatus | null,
): { appearance: ThemeAppearance; message: MessageDescriptorV2 } => {
	switch (status) {
		case 'OPEN':
			return { appearance: 'inprogress', message: messages.open };
		case 'MERGED':
			return { appearance: 'success', message: messages.merged };
		case 'DECLINED':
			return { appearance: 'removed', message: messages.declined };
		case 'UNKNOWN':
			return { appearance: 'new', message: messages.unknown };
		default:
			return { appearance: 'new', message: messages.unknown };
	}
};

const PRStatusLozenge = ({ status }: { status: DevOpsPullRequestStatus | null }) => {
	const { appearance, message } = getLozengeConfig(status);
	const { formatMessage } = useIntl();

	return <Lozenge appearance={appearance}>{formatMessage(message)}</Lozenge>;
};

export const PRStatusLozengeFragment = ({
	prStatusLozengeData,
}: {
	prStatusLozengeData: prStatusLozenge_softwareCodePage_PRStatusLozengeFragment$key;
}) => {
	const data = useFragment(
		graphql`
			fragment prStatusLozenge_softwareCodePage_PRStatusLozengeFragment on DevOpsPullRequestDetails {
				status
			}
		`,
		prStatusLozengeData,
	);

	// @ts-expect-error - Type 'DevOpsPullRequestStatus | null | undefined' is not assignable to type 'DevOpsPullRequestStatus | null'.
	return <PRStatusLozenge status={data.status} />;
};

export default PRStatusLozenge;
